import AccountCircle from '@mui/icons-material/AccountCircle'
import Timeline from '@mui/icons-material/Timeline'

export const itemMenus = {
    queue: {title: 'menuItems.queue', icon: <Timeline />, superUserOnly: true},
    profile: {title: 'menuItems.profile', icon: <AccountCircle />},
}
